import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { Payout } from './payout.entity';
import { PayoutStatus } from './payout.status.enum';

export class CreatePayoutDto extends Omit(Payout, [...BaseEntityFieldsArray, 'status'], ['status']) {
    status?: PayoutStatus;
}
